export class GoogleTagManagerService {
    private static instance: GoogleTagManagerService;
    private dataLayer: any;

    public static getInstance() {
        if (!GoogleTagManagerService.instance) {
            GoogleTagManagerService.instance = new GoogleTagManagerService();
        }

        return GoogleTagManagerService.instance;
    }

    public init() {
        console.log("[GoogleTagManager] Init GTM...");
        // @ts-ignore
        if (dataLayer !== undefined) {
            console.log("[GoogleTagManager] GTM service OK");
            // @ts-ignore
            this.dataLayer = dataLayer;
        } else {
            console.error("[GoogleTagManager] GTM service KO");
            this.dataLayer = undefined;
        }
    }

    public pushPageEvent(page: string, pageTitle: string, data: object) {
        if (this.dataLayer !== undefined) {
            console.log("[GoogleTagManagerService] Push page event!");
            this.dataLayer.push({
                event: 'virtualPageview',
                page: page,
                title: pageTitle,
                ...data
            })
        } else {
            console.error("[GoogleTagManagerService] Push Failed! No dataLayer");
        }
    }

    public pushPageAuthEvent(page: string, pageTitle: string | null, type: string | null, method: string | null) {
        if (this.dataLayer !== undefined) {
            console.log("[GoogleTagManagerService] Push page event!");
            this.dataLayer.push({
                event: 'virtualPageview',
                page: page,
                title: pageTitle,
                type: type,
                method: method
            })
        } else {
            console.error("[GoogleTagManagerService] Push Failed! No dataLayer");
        }
    }

    public pushPageLogin(eventName: string, data: object, id: string | null, tidMobilePos: object, tidSoftPos: any, userList: object, totalDev: number | null) {
        if (this.dataLayer !== undefined) {
            console.log("[GoogleTagManagerService] Push generic event!");
            this.dataLayer.push({
                event: eventName,
                ...data,
                merchant: {
                    id: id,
                    tid_mobile_pos: {
                        ...tidMobilePos
                    },
                    tid_soft_pos: {
                        ...tidSoftPos
                    },
                    users: {
                        ...userList
                    },
                    developers: {
                        total: totalDev
                    }
                }
            })
        } else {
            console.error("[GoogleTagManagerService] Push Failed! No dataLayer");
        }
    }


    public pushGenericEvent(eventName: string, data: object) {
        if (this.dataLayer !== undefined) {
            console.log("[GoogleTagManagerService] Push generic event!");
            this.dataLayer.push({
                event: eventName,
                ...data
            })
        } else {
            console.error("[GoogleTagManagerService] Push Failed! No dataLayer");
        }
    }

    public pushInteractionEvent(eventType: string, eventCategory: string, eventAction: string, eventLabel: string) {
        if (this.dataLayer !== undefined) {
            console.log("[GoogleTagManagerService] Push interaction event!");
            this.dataLayer.push({
                event: `gaEvent_${eventType}`,
                eventCategory: eventCategory,
                eventAction: eventAction,
                eventLabel: eventLabel
            })
        } else {
            console.error("[GoogleTagManagerService] Push Failed! No dataLayer");
        }
    }

    public pushCta(text: string, className: string, targetUrl: string) {
        if (this.dataLayer !== undefined) {
            console.log("[GoogleTagManagerService] Push CTA!");
            this.dataLayer.push({
                event: "cta_click",
                cta: {
                    text: text.toLowerCase(), //valorizzare con il testo della cta cliccata in lowercase
                    class: className, //valorizzare con classi html della CTA cliccata
                    targetUrl: targetUrl, //valorizzare con Url a cui punta la Cta cliccata
                }
            })
        } else {
            console.error("[GoogleTagManagerService] Push Failed! No dataLayer");
        }
    }

    public pushInputErrorEvent(message: string, type: string) {
        if (this.dataLayer !== undefined) {
            console.log("[GoogleTagManagerService] Push input error event!");
            this.dataLayer.push({
                event: 'inputError',
                message: message,
                type: type
            })
        } else {
            console.error("[GoogleTagManagerService] Push Failed! No dataLayer");
        }
    }

    public pushInputErrorWithFieldEvent(field: string, message: string) {
        if (this.dataLayer !== undefined) {
            console.log("[GoogleTagManagerService] Push input error event with field details!");
            this.dataLayer.push({
                event: 'inputError',
                field: field,
                message: message
            })
        } else {
            console.error("[GoogleTagManagerService] Push Failed! No dataLayer");
        }
    }

    public pushGenericError(message: string, code: string, description: string) {
        if (this.dataLayer !== undefined) {
            console.log("[GoogleTagManagerService] Push generic event!");
            this.dataLayer.push({
                event: 'genericError',
                message: message,
                code: code,
                description: description
            })
        } else {
            console.error("[GoogleTagManagerService] Push Failed! No dataLayer");
        }
    }

    public pushCustomError(event: string = "custom_error", error_type: string, error_code: string | null, error_message: string, error_field: string | undefined, is_fatal: boolean = false) {
        if (this.dataLayer !== undefined) {
            console.log("[GoogleTagManagerService] Push custom error!");
            this.dataLayer.push({
                event: event,
                error: {
                    type: error_type,
                    code: error_code,
                    message: error_message,
                    field: error_field,
                    is_fatal: is_fatal
                }
            })
        } else {
            console.error("[GoogleTagManagerService] Push Failed! No dataLayer");
        }
    }


    public pushRequestOutcome(id: string | undefined, code: number, status: number, message: string | null) {
        if (this.dataLayer !== undefined) {
            console.log("[GoogleTagManagerService] Push custom error!");
            this.dataLayer.push({
                event: 'request_outcome',
                request: {
                    id: id,
                    description: 'richiesta utenza sviluppatore'
                },
                response: {
                    code: code,
                    status: status,
                    message: message
                }
            })
        } else {
            console.error("[GoogleTagManagerService] Push Failed! No dataLayer");
        }
    }

    public pushNewRequest(text: string | undefined, classes: string | undefined, targetUrl: string | undefined) {
        if (this.dataLayer !== undefined) {
            console.log("[GoogleTagManagerService] Push custom error!");
            this.dataLayer.push({
                event: 'cta_click',
                cta: {
                    text: text?.toLowerCase(),
                    class: classes,
                    targetUrl: targetUrl,
                }
            })
        } else {
            console.error("[GoogleTagManagerService] Push Failed! No dataLayer");
        }
    }

    public pushPopupImpression(event: string, category: string, action: string, label: string) {
        if (this.dataLayer !== undefined) {
            console.log("[GoogleTagManagerService] Push popup impression!");
            this.dataLayer.push({
                event: event,
                eventCategory: category,
                eventAction: action,
                eventLabel: label
            })
        } else {
            console.error("[GoogleTagManagerService] Push Failed! No dataLayer");
        }
    }
}